import { _ as s } from "./index946.mjs";
var n = s;
function r(t) {
  var a = this.__data__, e = n(a, t);
  return e < 0 ? void 0 : a[e][1];
}
var d = r;
export {
  d as _
};
